export const tradeConfirmActions = {
    CONFIRM_TRADE_POPUP_VISIBLE: 'tradeConfirm/CONFIRM_TRADE_POPUP_VISIBLE',
    SET_AWAITING_TRADED_POSITIONS: 'tradeConfirm/SET_AWAITING_TRADED_POSITIONS',
    SET_TRADED_POSITION_STATUS: 'tradeConfirm/SET_TRADED_POSITION_STATUS',
    REMOVE_PROCESSED_TADED_POSITIONS: 'tradeConfirm/REMOVE_PROCESSED_TADED_POSITIONS',
    SET_OPERATIONS_PROGRESS: 'tradeConfirm/SET_OPERATIONS_PROGRESS',
    RESET: 'tradeConfirm/RESET'
}
